import React, { useState } from "react";
import classnames from "classnames";
import { makeStyles } from "@mui/styles";
import { useSnackbar, SnackbarContent } from "notistack";
import Collapse from "@mui/material/Collapse";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("sm")]: {
      minWidth: "344px !important",
    },
  },
  card: {
    backgroundColor: "red",
    width: "100%",
  },
  typography: {
    fontWeight: "bold",
    color: "black",
  },
  actionRoot: {
    padding: "8px 8px 8px 16px",
  },
  icons: {
    marginLeft: "auto",
    color: "black",
  },
  expand: {
    padding: "8px 8px",
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  collapse: {
    padding: 16,
  },
  checkIcon: {
    fontSize: 20,
    color: "#b3b3b3",
    paddingRight: 4,
  },
  button: {
    padding: 0,
    textTransform: "none",
  },
}));

const DetailsError = React.forwardRef((props, ref) => {
  const { id, errorMessage, label = "An unexpected error has occurred" } = props;
  const classes = useStyles();
  const { closeSnackbar } = useSnackbar();
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleDismiss = () => {
    closeSnackbar(id);
  };

  return (
    <SnackbarContent ref={ref} className={classes.root}>
      <Card className={classes.card}>
        <CardActions classes={{ root: classes.actionRoot }}>
          <Typography className={classes.typography} variant="subtitle2">
            {label}
          </Typography>
          <div className={classes.icons}>
            {errorMessage && (
              <IconButton
                aria-label="Show Details"
                className={classnames(classes.expand, { [classes.expandOpen]: expanded })}
                onClick={handleExpandClick}
              >
                <ExpandMoreIcon style={{ color: "black" }} />
              </IconButton>
            )}
            <IconButton className={classes.expand} onClick={handleDismiss}>
              <CloseIcon style={{ color: "black" }} />
            </IconButton>
          </div>
        </CardActions>
        <Collapse unmountOnExit in={expanded} timeout="auto">
          <Paper className={classes.collapse}>
            <Typography gutterBottom>Error Details</Typography>
            {errorMessage}
            <br />
            <a href="mailto:cazcon@techint.com?subject=Error en Reports">Contact Support</a>
          </Paper>
        </Collapse>
      </Card>
    </SnackbarContent>
  );
});

export default DetailsError;
